'use client';

import { __assign, __spreadArray } from '../_virtual/_tslib.js';
import { sortOptionsAlphabet, sortChildOptionAlphabet } from '../TreeSelect/helpers.js';
import { ELanguage } from '../Utils/constants.js';
import { transformToLatin } from '../Utils/helpers.js';
import { OTHER_PARENT_ID, DEFAULT_FLOATING_CONFIG, DEFAULT_STYLE_OPTION, DEFAULT_SELECT_OPTIONS, DEFAULT_TEXT_OPTIONS } from './constants.js';

var mergeJobCount = function (options, children, jobCount) {
    var mergedParents = [];
    var mergedChildrens = children;
    var childrenKeys = Object.keys(children);
    var _loop_1 = function (i) {
        var parentItem = options[i];
        var filteredJobCount = jobCount && jobCount.filter(function (item) { return item.parentId === parentItem.id; });
        // Push jobs count for parent
        mergedParents.push({
            id: parentItem.id,
            name: parentItem.name,
            jobs: filteredJobCount.length > 0 ? filteredJobCount[0].jobs : 0
        });
        if (!filteredJobCount ||
            filteredJobCount.length === 0 ||
            (filteredJobCount.length > 0 && filteredJobCount[0].children.length === 0)) {
            return "continue";
        }
        var parentIndex = childrenKeys.findIndex(function (item) { return item === parentItem.id.toString(); });
        var _loop_2 = function (j) {
            var childrenItem = filteredJobCount[0].children[j];
            var childItemIndex = mergedChildrens[parentIndex].findIndex(function (childItem) { return childItem.id === childrenItem.childrenId; });
            if (childItemIndex === -1) {
                return "continue";
            }
            // Set children jobs count
            mergedChildrens[parentIndex][childItemIndex].jobs = childrenItem.jobs;
        };
        for (var j = 0; j < filteredJobCount[0].children.length; j++) {
            _loop_2(j);
        }
    };
    // Merge parent
    for (var i = 0; i < options.length; i++) {
        _loop_1(i);
    }
    // Merge children
    return [mergedParents, mergedChildrens];
};
var mergeProps = function (props) {
    var _a, _b;
    var floatingConfig = props.floatingConfig, options = props.options, langCode = props.langCode, styleOptions = props.styleOptions, selectOptions = props.selectOptions, textOptions = props.textOptions;
    var parent = options.parent, children = options.children, jobCount = options.jobCount, isEnableSearchAPI = options.isEnableSearchAPI;
    // Merge floating config
    var mergedFloatingConfig = __assign(__assign({}, DEFAULT_FLOATING_CONFIG), floatingConfig);
    var mergedStyleOptions = __assign(__assign({}, DEFAULT_STYLE_OPTION), styleOptions);
    var mergedSelectOptions = __assign(__assign({}, DEFAULT_SELECT_OPTIONS), selectOptions);
    var mergedTextOptions = __assign(__assign({}, DEFAULT_TEXT_OPTIONS), textOptions);
    // Sort parent, children option first
    var sortedParent = sortOptionsAlphabet(parent, true);
    // Remove 'Others' || 'Khác' parent out of array then push it to bottom
    var filteredOther = sortedParent.filter(function (item) { return item.id === OTHER_PARENT_ID; });
    sortedParent = sortedParent.filter(function (item) { return item.id !== OTHER_PARENT_ID; });
    if (filteredOther.length > 0) {
        sortedParent.push(filteredOther[0]);
    }
    var sortedChildren = sortChildOptionAlphabet(children, langCode, true);
    // Map job count to each job function
    var _c = mergeJobCount(sortedParent, sortedChildren, jobCount), optionParents = _c[0], optionChildrens = _c[1];
    return __assign(__assign({}, props), { lockTarget: (_a = props.lockTarget) !== null && _a !== void 0 ? _a : '', scrollLockMode: (_b = props.scrollLockMode) !== null && _b !== void 0 ? _b : 'hard', floatingConfig: mergedFloatingConfig, styleOptions: mergedStyleOptions, selectOptions: mergedSelectOptions, textOptions: mergedTextOptions, options: {
            parent: optionParents,
            children: optionChildrens,
            isEnableSearchAPI: isEnableSearchAPI
        } });
};
var sortSearchChildrenAlphabet = function (options, isSortAlphabet) {
    if (!isSortAlphabet) {
        return options;
    }
    var removedItem = null;
    var filteredHaveAllItem = options.filter(function (item) { return item.parentId === -1; });
    if (filteredHaveAllItem.length > 0) {
        removedItem = options.splice(0, 1);
    }
    options.sort(function (itemA, itemB) {
        if (itemA.parentName < itemB.parentName) {
            return -1;
        }
        if (itemA.parentName > itemB.parentName) {
            return 1;
        }
        return 0;
    });
    if (removedItem !== null) {
        return __spreadArray(__spreadArray([], removedItem, true), options, true);
    }
    return options;
};
var getParentByChildrenId = function (id, parent, children) {
    var childrenIndexKey = Object.keys(children);
    var childrens = Object.values(children);
    var _loop_3 = function (i) {
        var parentItem = childrens[i];
        var filteredChildItems = parentItem.filter(function (item) { return item.id === id; });
        if (filteredChildItems.length === 0) {
            return "continue";
        }
        var parentId = Number(childrenIndexKey[i]);
        var filteredParent = parent.filter(function (item) { return item.id === parentId; });
        if (filteredParent.length === 0) {
            return "continue";
        }
        return { value: filteredParent[0] };
    };
    for (var i = 0; i < childrens.length; i++) {
        var state_1 = _loop_3(i);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return null;
};
var filterResult = function (_a) {
    var _b;
    var keyword = _a.keyword, parent = _a.parent, children = _a.children, langCode = _a.langCode;
    var childrenIndexKey = Object.keys(children);
    var childrens = Object.values(children);
    var formattedKeyword = transformToLatin(keyword).toLowerCase();
    var responseParent = [];
    var responseChildren = [];
    var _loop_4 = function (i) {
        var child = childrens[i];
        // Looking for children name that match keyword
        var filteredChildren = child.filter(function (item) {
            var convertedItemName = transformToLatin(langCode === ELanguage.EN ? item.nameEn : item.name).toLowerCase();
            return convertedItemName.indexOf(formattedKeyword) >= 0;
        });
        if (filteredChildren.length === 0) {
            return "continue";
        }
        // Found match children
        var parentId = Number((_b = childrenIndexKey[i]) !== null && _b !== void 0 ? _b : '-1');
        var filteredParents = parent.filter(function (parentItem) { return parentItem.id === parentId; });
        var parentName = '';
        if (filteredParents.length > 0) {
            parentName = filteredParents[0].name;
            responseParent.push({
                id: parentId,
                name: parentName,
                jobs: filteredParents[0].jobs
            });
        }
        // Push to responseChildren array
        responseChildren.push({
            parentId: parentId,
            parentName: parentName,
            childrens: filteredChildren
        });
    };
    for (var i = 0; i < childrens.length; i++) {
        _loop_4(i);
    }
    // Filter parent
    var filteredParent = parent.filter(function (optionItem) {
        var convertedItemName = transformToLatin(optionItem.name).toLowerCase();
        return convertedItemName.indexOf(formattedKeyword) >= 0;
    });
    var _loop_5 = function (i) {
        var firstItem = filteredParent[i];
        var filteredMatch = responseParent.filter(function (secondItem) { return secondItem.id === firstItem.id; });
        if (filteredMatch.length > 0) {
            return "continue";
        }
        responseParent.push(firstItem);
    };
    // Filter matched from children
    for (var i = 0; i < filteredParent.length; i++) {
        _loop_5(i);
    }
    // Sort parent by Alphabet
    var sortedParents = sortOptionsAlphabet(responseParent, true);
    // Filter 'Khác' || 'Other' to bottom
    // Remove 'Others' || 'Khác' parent out of array then push it to bottom
    var filteredOther = sortedParents.filter(function (item) { return item.id === OTHER_PARENT_ID; });
    sortedParents = sortedParents.filter(function (item) { return item.id !== OTHER_PARENT_ID; });
    if (filteredOther.length > 0) {
        sortedParents.push(filteredOther[0]);
    }
    var sortedChildrens = sortSearchChildrenAlphabet(responseChildren, true);
    return [sortedParents, sortedChildrens];
};
var getFilteredDuplicateChildren = function (filteredChildren, searchResult) {
    var jobFunctions = searchResult.jobFunctions;
    var filteredDuplicateChildren = [];
    var _loop_6 = function (i) {
        var childItem = filteredChildren[i];
        if (!childItem || jobFunctions.some(function (item) { return item.id === childItem.parentId; })) {
            filteredDuplicateChildren.push(jobFunctions[filteredDuplicateChildren.length]);
        }
    };
    // Only get response from API
    for (var i = 0; i < jobFunctions.length; i++) {
        _loop_6(i);
    }
    return filteredDuplicateChildren;
};
var mapToAPIResponseItems = function (filteredDuplicateChildren, parent, children) {
    var apiResponseItems = [];
    filteredDuplicateChildren.forEach(function (item) {
        var _a;
        if (!item) {
            return;
        }
        var parentInfo = getParentByChildrenId(item.id, parent, children);
        apiResponseItems.push({
            parentId: parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.id,
            parentName: (_a = parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.name) !== null && _a !== void 0 ? _a : '',
            childrens: [
                {
                    id: item.id,
                    name: item.attributes.nameVi,
                    nameEn: item.attributes.nameEn
                }
            ]
        });
    });
    return apiResponseItems;
};
var filterResultByAPI = function (_a) {
    var searchResult = _a.searchResult, parent = _a.parent, children = _a.children, langCode = _a.langCode, keyword = _a.keyword;
    var _b = filterResult({
        keyword: keyword,
        parent: parent,
        children: children,
        langCode: langCode
    }), filteredParent = _b[0], filteredChildren = _b[1];
    var filteredDuplicateChildren = getFilteredDuplicateChildren(filteredChildren, searchResult);
    var apiResponseItems = mapToAPIResponseItems(filteredDuplicateChildren, parent, children);
    return [filteredParent, __spreadArray(__spreadArray([], filteredChildren, true), apiResponseItems, true)];
};
var getParentCheckState = function (parentId, temporaryValue) {
    var checkState = 'none';
    var filteredValue = temporaryValue.filter(function (item) { return item.parentId === parentId; });
    if (filteredValue.length > 0) {
        var isHaveAllOption = filteredValue[0].childrenIds.includes(-1);
        checkState = isHaveAllOption ? 'checked' : 'half';
    }
    return checkState;
};
var getChildrenCheckState = function (parentId, childrenId, temporaryValue) {
    var checkState = 'none';
    // Filter parent first
    var filteredValue = temporaryValue.filter(function (item) { return item.parentId === parentId; });
    if (filteredValue.length === 0) {
        return checkState;
    }
    // Get children from parent
    // parentId is unique so there is only one result
    var filteredChildrens = filteredValue[0].childrenIds.filter(function (item) { return item === childrenId; });
    if (filteredChildrens.length === 0) {
        return checkState;
    }
    checkState = 'checked';
    return checkState;
};
var getSelectedParentName = function (value, option) {
    var selectedValues = [];
    if (value.length === 0) {
        return [];
    }
    var _loop_7 = function (i) {
        var selectedParent = value[i];
        var filteredParents = option.filter(function (item) { return item.id === selectedParent.parentId; });
        if (filteredParents.length === 0) {
            return "continue";
        }
        selectedValues.push(filteredParents[0]);
    };
    for (var i = 0; i < value.length; i++) {
        _loop_7(i);
    }
    return selectedValues;
};
var getSelectedSingleChildrenName = function (value, children) {
    if (value.length === 0) {
        return null;
    }
    if (value[0].childrenIds.length === 0) {
        return null;
    }
    var selectedChildId = value[0].childrenIds[0];
    var childrens = Object.values(children);
    // Filter children
    var responseChildren = null;
    for (var i = 0; i < childrens.length; i++) {
        var parentItem = childrens[i];
        var filteredChildren = parentItem.filter(function (item) { return item.id === selectedChildId; });
        if (filteredChildren.length === 0) {
            continue;
        }
        responseChildren = filteredChildren[0];
    }
    return responseChildren;
};
var countSelectedChildrenFromParentId = function (parentId, temporaryValue) {
    var _a, _b, _c;
    var filteredParents = temporaryValue.filter(function (item) { return item.parentId === parentId; });
    if (filteredParents.length <= 0) {
        return 0;
    }
    if (filteredParents[0].childrenIds.length === 0) {
        return 0;
    }
    if (filteredParents[0].childrenIds[0] === -1) {
        return -1;
    }
    return (_c = (_b = (_a = filteredParents[0]) === null || _a === void 0 ? void 0 : _a.childrenIds) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
};

export { countSelectedChildrenFromParentId, filterResult, filterResultByAPI, getChildrenCheckState, getParentByChildrenId, getParentCheckState, getSelectedParentName, getSelectedSingleChildrenName, mergeJobCount, mergeProps, sortSearchChildrenAlphabet };
//# sourceMappingURL=helper.js.map
